export default {
  lang_name: '\uD55C\uAD6D\uC5B4',
  tab_main: '\uBA54\uC778', tab_upgrade: '\uC5C5\uADF8\uB808\uC774\uB4DC', tab_prestige: '\uD658\uC0DD', tab_achievement: '\uC5C5\uC801', tab_mission: '\uBBF8\uC158', tab_domination: '\uC815\uBCF5', tab_settings: '\uC124\uC815',
  hud_cps: '/\uCD08', hud_boost: '\uBD80\uC2A4\uD2B8',
  main_tap_area: '\uD0ED!', main_combo: '\uCF64\uBCF4',

  prod_informant: '\uC815\uBCF4\uC6D0', prod_informant_desc: '\uAC70\uB9AC\uC5D0\uC11C \uC815\uBCF4 \uC218\uC9D1',
  prod_hacker: '\uD574\uCEE4', prod_hacker_desc: '\uC778\uAC04 \uB124\uD2B8\uC6CC\uD06C \uCE68\uC785',
  prod_disguiser: '\uBCC0\uC7A5 \uC804\uBB38\uAC00', prod_disguiser_desc: '\uC778\uAC04\uC73C\uB85C \uBCC0\uC7A5\uD558\uC5EC \uCE68\uD22C',
  prod_mindController: '\uC2EC\uB9AC \uC870\uC885\uC0AC', prod_mindController_desc: '\uC778\uAC04 \uC5EC\uB860 \uC870\uC791',
  prod_secretLab: '\uBE44\uBC00 \uC5F0\uAD6C\uC18C', prod_secretLab_desc: '\uB80C\uD2F8\uB9AC\uC5B8 \uAE30\uC220 \uC5F0\uAD6C',
  prod_mediaCell: '\uBBF8\uB514\uC5B4 \uC870\uC791\uBC18', prod_mediaCell_desc: '\uB274\uC2A4/SNS \uC7A5\uC545',
  prod_shadowGovt: '\uADF8\uB9BC\uC790 \uC815\uBD80', prod_shadowGovt_desc: '\uC815\uCE58\uC778 \uAD50\uCCB4 \uC791\uC804',
  prod_deepBase: '\uC2EC\uCE35 \uAE30\uC9C0', prod_deepBase_desc: '\uC9C0\uD558 \uAC70\uB300 \uAE30\uC9C0 \uC6B4\uC601',
  prod_orbitalStation: '\uADA4\uB3C4 \uC704\uC131', prod_orbitalStation_desc: '\uC778\uACF5\uC704\uC131 \uAC10\uC2DC\uB9DD',
  prod_dimensionGate: '\uCC28\uC6D0 \uAC8C\uC774\uD2B8', prod_dimensionGate_desc: '\uBCF8\uC131\uC5D0\uC11C \uBCD1\uB825 \uC18C\uD658',
  prod_planetController: '\uD589\uC131 \uC81C\uC5B4\uAE30', prod_planetController_desc: '\uC9C0\uAD6C \uC2DC\uC2A4\uD15C \uC9C1\uC811 \uC870\uC791',
  prod_galacticBeacon: '\uC740\uD558 \uC2E0\uD638\uAE30', prod_galacticBeacon_desc: '\uC740\uD558 \uBCF8\uBD80\uC640 \uC9C1\uD1B5',
  prod_locked: '\uD574\uAE08: ', prod_locked_prestige: '\uD658\uC0DD {n}\uD68C', prod_locked_time: '{n}\uBD84 \uD50C\uB808\uC774',

  milestone_squad: '\uC18C\uADDC\uBAA8 \uBD84\uB300 \uD3B8\uC131', milestone_company: '\uC911\uB300 \uD3B8\uC131 \uC644\uB8CC',
  milestone_battalion: '\uB300\uB300\uAE09 \uC804\uB825', milestone_regiment: '\uC5F0\uB300\uAE09 \uC804\uB825',
  milestone_division: '\uC0AC\uB2E8\uAE09 \uC804\uB825', milestone_corps: '\uAD70\uB2E8\uAE09 \uC804\uB825',

  click_basic_training: '\uAE30\uBCF8 \uD6C8\uB828', click_combat_training: '\uC804\uD22C \uD6C8\uB828',
  click_psychic_awaken: '\uC0AC\uC774\uD0A5 \uAC01\uC131', click_transform: '\uBCC0\uC2E0 \uAC15\uD654',
  click_telepathy: '\uD154\uB808\uD30C\uC2DC', click_critical_eye: '치명적 안목',
  click_dimension_sense: '\uCC28\uC6D0 \uAC10\uAC01', click_galaxy_field: '\uC740\uD558 \uC5ED\uC7A5',
  click_lethal_strike: '필살 일격', click_absolute: '\uC808\uB300 \uCE68\uD22C\uB825',
  click_planet_destroyer: '\uD589\uC131 \uD30C\uAD34\uC790', click_galaxy_finger: '\uC740\uD558 \uC9C0\uBC30\uC790\uC758 \uC190\uAC00\uB77D',

  special_info_network: '\uC815\uBCF4 \uB124\uD2B8\uC6CC\uD06C', special_info_network_desc: '\uC815\uBCF4\uC6D0 & \uD574\uCEE4 \uC218\uC775 x2',
  special_perfect_disguise: '\uC644\uBCBD\uD55C \uC704\uC7A5', special_perfect_disguise_desc: '\uBAA8\uB4E0 \uC694\uC6D0 \uC218\uC775 x1.5',
  special_mass_brainwash: '\uB300\uC911 \uC138\uB1CC', special_mass_brainwash_desc: '\uC2EC\uB9AC\uC870\uC885\uC0AC & \uBBF8\uB514\uC5B4 \uC218\uC775 x3',
  special_shadow_network: '\uADF8\uB9BC\uC790 \uB124\uD2B8\uC6CC\uD06C', special_shadow_network_desc: '\uC624\uD504\uB77C\uC778 \uC218\uC775 +25%',
  special_underground_empire: '\uC9C0\uD558 \uC81C\uAD6D', special_underground_empire_desc: '\uBAA8\uB4E0 \uC694\uC6D0 \uC218\uC775 x2',
  special_orbital_surveillance: '\uADA4\uB3C4 \uAC10\uC2DC\uB9DD', special_orbital_surveillance_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 \uBE48\uB3C4 +50%',
  special_dimension_supply: '\uCC28\uC6D0 \uBCD1\uCC38\uC120', special_dimension_supply_desc: '\uD0ED \uC218\uC775 x5',
  special_galactic_alliance: '\uC740\uD558 \uB3D9\uB9F9', special_galactic_alliance_desc: '\uCD08\uB2F9 \uD83D\uDEF8 \uC218\uC775 x10',
  special_combo_master: '\uCF64\uBCF4 \uB9C8\uC2A4\uD130', special_combo_master_desc: '\uCF64\uBCF4 \uBC30\uC728 \uC0C1\uD55C 3\uBC30',
  special_time_warp: '\uC2DC\uAC04 \uC654\uACE1', special_time_warp_desc: '\uC624\uD504\uB77C\uC778 \uCE61 12\uC2DC\uAC04',
  special_agent_synergy: '\uC694\uC6D0 \uC2DC\uB108\uC9C0', special_agent_synergy_desc: '\uCD08\uB2F9 \uD83D\uDEF8 \uC218\uC775 x1.5',
  special_massive_infiltration: '\uB300\uADDC\uBAA8 \uCE68\uD22C', special_massive_infiltration_desc: '\uCD08\uB2F9 \uD83D\uDEF8 \uC218\uC775 x2',

  subtab_click: '\uD074\uB9AD', subtab_special: '\uD2B9\uC218',

  prestige_title: '\uC870\uC9C1 \uC7AC\uD3B8', prestige_total_ip: '\uCD1D \uB204\uC801 \uD83D\uDEF8',
  prestige_gc_gain: '\uD68D\uB4DD \uC608\uC815 \uD83D\uDC8E', prestige_gc_current: '\uD604\uC7AC \uD83D\uDC8E',
  prestige_execute: '\uC870\uC9C1 \uC7AC\uD3B8', prestige_confirm: '\uBAA8\uB4E0 \uC9C4\uD589\uC744 \uB9AC\uC14B\uD558\uACE0 {gc} \uD83D\uDC8E\uC744 \uD68D\uB4DD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
  prestige_ad_bonus: '\uAD11\uACE0 \uBCF4\uACE0 \uD83D\uDC8E +50%',
  prestige_requirement: '\uD658\uC0DD\uC5D0\uB294 100\uC5B5 \uD83D\uDEF8 \uC774\uC0C1 \uD544\uC694',
  prestige2_title: '\uC740\uD558 \uC7AC\uD3B8', prestige2_cores_gain: '\uD68D\uB4DD \uC608\uC815 \uD83D\uDD2E',
  prestige2_cores_current: '\uD604\uC7AC \uD83D\uDD2E', prestige2_execute: '\uC740\uD558 \uC7AC\uD3B8',
  prestige2_requirement: '\uD658\uC0DD 15\uD68C \uC774\uC0C1 & \uCD1D \uD83D\uDC8E 100 \uC774\uC0C1 \uD544\uC694',
  prestige2_confirm: '\uBAA8\uB4E0 \uAC83\uC744 \uCD08\uAE30\uD654\uD558\uACE0 {cores} \uD83D\uDD2E\uB97C \uD68D\uB4DD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',

  pup_galaxy_mult: '\uC740\uD558 \uBC30\uC728', pup_galaxy_mult_desc: '\uB808\uBCA8\uB2F9 \uCD08\uB2F9 \uC218\uC775 x1.5 (\uB808\uBCA8\uC774 \uC624\uB97C\uC218\uB85D \uBC30\uB85C \uC911\uCCA9)',
  pup_infil_accel: '\uCE68\uD22C \uAC00\uC18D', pup_infil_accel_desc: '\uD658\uC0DD \uC2DC \uB808\uBCA8\uB2F9 1\uC5B5 \uD83D\uDEF8\uB97C \uAC00\uC9C0\uACE0 \uC2DC\uC791',
  pup_tap_enhance: '\uD0ED \uAC15\uD654', pup_tap_enhance_desc: '\uB808\uBCA8\uB2F9 \uD0ED \uC218\uC775 x2 (\uBC30\uB85C \uC911\uCCA9)',
  pup_offline_expand: '\uC624\uD504\uB77C\uC778 \uD655\uC7A5', pup_offline_expand_desc: '\uC811\uC18D \uC548 \uD560 \uB54C \uBCF4\uC0C1 \uCD5C\uB300 \uC2DC\uAC04 +1h/Lv (\uAE30\uBCF8 8h)',
  pup_offline_eff: '\uC624\uD504\uB77C\uC778 \uD6A8\uC728', pup_offline_eff_desc: '\uC624\uD504\uB77C\uC778 \uC218\uC775\uB960 +10%p/Lv (\uAE30\uBCF8 50%)',
  pup_agent_discount: '\uC694\uC6D0 \uD560\uC778', pup_agent_discount_desc: '\uB808\uBCA8\uB2F9 \uC694\uC6D0 \uACE0\uC6A9 \uBE44\uC6A9 -10% (\uCD5C\uB300 -50%)',
  pup_auto_click: '\uC790\uB3D9 \uD074\uB9AD', pup_auto_click_desc: '\uB808\uBCA8\uB2F9 \uCD08\uB2F9 3\uD68C \uC790\uB3D9 \uD0ED (\uCD5C\uB300 15\uD68C/\uCD08)',
  pup_golden_luck: '\uD669\uAE08 \uC6B4', pup_golden_luck_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 \uBCF4\uC0C1 +20%/Lv (\uCD5C\uB300 +200%)',
  pup_combo_keep: '\uCF64\uBCF4 \uC720\uC9C0', pup_combo_keep_desc: '\uCF64\uBCF4 \uC720\uD6A8\uC2DC\uAC04 +0.5\uCD08/Lv (\uAE30\uBCF8 2\uCD08)',
  pup_quick_start: '\uBE60\uB978 \uC2DC\uC791', pup_quick_start_desc: '\uD658\uC0DD \uD6C4 \uCCAB 5\uAC1C \uC694\uC6D0\uC744 1\uBA85\uC529 \uC790\uB3D9 \uC9C0\uAE09',

  p2up_galaxy_speed: '\uC740\uD558 \uBC30\uC18D', p2up_galaxy_speed_desc: '\uB808\uBCA8\uB2F9 \uD658\uC0DD \uC2DC \uD83D\uDC8E \uD68D\uB4DD\uB7C9 x2 (\uBC30\uB85C \uC911\uCCA9)',
  p2up_auto_prestige: '\uC790\uB3D9 \uD658\uC0DD', p2up_auto_prestige_desc: '100\uC5B5 \uD83D\uDEF8 \uB3C4\uB2EC \uC2DC \uC790\uB3D9\uC73C\uB85C \uD658\uC0DD \uC2E4\uD589',
  p2up_permanent: '\uC601\uAD6C \uC694\uC6D0', p2up_permanent_desc: '\uD658\uC0DD \uD6C4\uC5D0\uB3C4 \uCD08\uAE30 \uC694\uC6D0 3\uC885\uC744 \uBCF4\uC874',
  p2up_dimension_accel: '\uCC28\uC6D0 \uAC00\uC18D', p2up_dimension_accel_desc: '\uB808\uBCA8\uB2F9 \uCD08\uB2F9 \uC218\uC775 x5 (\uBC30\uB85C \uC911\uCCA9, \uC601\uAD6C)',
  p2up_galaxy_memory: '\uC740\uD558 \uBA54\uBAA8\uB9AC', p2up_galaxy_memory_desc: '\uD658\uC0DD \uC2DC \uD65C\uC131\uD654\uB41C \uBD80\uC2A4\uD2B8 3\uAC1C\uB97C \uC720\uC9C0',
  p2up_spacetime: '\uC2DC\uACF5\uAC04 \uC654\uACE1', p2up_spacetime_desc: '\uC624\uD504\uB77C\uC778 \uC218\uC775\uB960\uC744 100%\uB85C \uC0C1\uD5A5 (\uC601\uAD6C)',
  p2up_automate: '\uC740\uD558 \uC790\uB3D9\uD654', p2up_automate_desc: '\uC694\uC6D0\uC744 \uC790\uB3D9\uC73C\uB85C \uACE0\uC6A9 (\uC601\uAD6C)',

  rank_e: '\uC778\uD134 \uC694\uC6D0', rank_d: '\uD558\uAE09 \uC694\uC6D0', rank_c: '\uC911\uAE09 \uC694\uC6D0', rank_b: '\uC0C1\uAE09 \uC694\uC6D0',
  rank_a: '\uAC04\uBD80', rank_s: '\uC9C0\uBD80\uC7A5', rank_ss: '\uCD1D\uC218', rank_sss: '\uC740\uD558 \uB300\uAD70\uC8FC',

  ach_title: '\uC5C5\uC801', ach_filter_all: '\uC804\uCCB4', ach_filter_tap: '\uD0ED', ach_filter_resource: '\uC790\uC6D0',
  ach_filter_producer: '\uC0DD\uC0B0\uAE30', ach_filter_prestige: '\uD658\uC0DD', ach_filter_time: '\uC2DC\uAC04',
  ach_filter_special: '\uD2B9\uC218', ach_filter_ad: '\uBB38\uC11C', ach_filter_combo: '\uCF64\uBCF4',

  ach_t01: '\uCCAB \uBC1C\uAC78\uC74C', ach_t01_reward: '\uD0ED \uD30C\uC6CC +1',
  ach_t02: '\uC190\uAC00\uB77D \uC6CC\uBC0D\uC5C5', ach_t02_reward: '\uD0ED \uD30C\uC6CC +5%',
  ach_t03: '\uAFB8\uC900\uD55C \uC694\uC6D0', ach_t03_reward: '\uD0ED \uD30C\uC6CC +10%',
  ach_t04: '\uD130\uCE58 \uB9C8\uC2A4\uD130', ach_t04_reward: '\uD0ED \uD30C\uC6CC +15%',
  ach_t05: '\uD30C\uCDA9\uB958\uC758 \uC9D1\uB150', ach_t05_reward: '\uD0ED \uD30C\uC6CC +20%',
  ach_t06: '\uC740\uD558\uAE09 \uC190\uAC00\uB77D', ach_t06_reward: '\uD0ED \uD30C\uC6CC +25%',
  ach_t07: '\uCF64\uBCF4 \uACAC\uC2B5\uC0DD', ach_t07_reward: '\uCF64\uBCF4 \uC720\uC9C0 +0.5\uCD08',
  ach_t08: '\uCF64\uBCF4 \uB9C8\uC2A4\uD130', ach_t08_reward: '\uCF64\uBCF4 \uBC30\uC728 \uC0C1\uD55C +0.5',

  ach_r01: '\uC18C\uC18C\uD55C \uC815\uBCF4', ach_r01_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +5%',
  ach_r02: '\uC815\uBCF4 \uC218\uC9D1\uAC00', ach_r02_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +5%',
  ach_r03: '\uAE30\uBC00 \uBCF4\uAD00\uD568', ach_r03_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +5%',
  ach_r04: '\uBC31\uB9CC \uCE68\uD22C', ach_r04_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_r05: '\uC5B5 \uB2E8\uC704 \uC694\uC6D0', ach_r05_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_r06: '\uC870 \uB2E8\uC704 \uC791\uC804', ach_r06_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +15%',
  ach_r07: '\uACBD \uB2E8\uC704 \uC81C\uAD6D', ach_r07_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +15%',
  ach_r08: '\uD574 \uB2E8\uC704 \uC740\uD558', ach_r08_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +20%',
  ach_r09: '\uC790 \uB2E8\uC704 \uC6B0\uC8FC', ach_r09_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +20%',
  ach_r10: '\uBB34\uD55C \uCE68\uD22C', ach_r10_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +30%',

  ach_g01: '\uCCAB \uBD80\uD558', ach_g01_reward: '\uC815\uBCF4\uC6D0 x1.5',
  ach_g02: '\uC815\uBCF4\uB9DD \uAD6C\uCD95', ach_g02_reward: '\uC815\uBCF4\uC6D0 x2',
  ach_g03: '\uD574\uD0B9 \uC2DC\uC791', ach_g03_reward: '\uD574\uCEE4 x2',
  ach_g04: '\uC0AC\uC774\uBC84 \uAD70\uB2E8', ach_g04_reward: '\uD574\uCEE4 x3',
  ach_g05: '\uC704\uC7A5\uC758 \uB2EC\uC778', ach_g05_reward: '\uBCC0\uC7A5 \uC804\uBB38\uAC00 x2',
  ach_g06: '\uC138\uB1CC \uB124\uD2B8\uC6CC\uD06C', ach_g06_reward: '\uC2EC\uB9AC \uC870\uC885\uC0AC x2',
  ach_g07: '\uB9E4\uB4DC \uC0AC\uC774\uC5B8\uC2A4', ach_g07_reward: '\uBE44\uBC00 \uC5F0\uAD6C\uC18C x2',
  ach_g08: '\uBBF8\uB514\uC5B4 \uC7A5\uC545', ach_g08_reward: '\uBBF8\uB514\uC5B4 \uC870\uC791\uBC18 x2',
  ach_g09: '\uADF8\uB9BC\uC790 \uB0B4\uAC01', ach_g09_reward: '\uADF8\uB9BC\uC790 \uC815\uBD80 x2',
  ach_g10: '\uC9C0\uD558 \uC81C\uAD6D', ach_g10_reward: '\uC2EC\uCE35 \uAE30\uC9C0 x2',
  ach_g11: '\uADA4\uB3C4 \uC9C0\uBC30', ach_g11_reward: '\uADA4\uB3C4 \uC704\uC131 x2',
  ach_g12: '\uC740\uD558\uC758 \uC8FC\uC778', ach_g12_reward: '\uC804\uCCB4 \uCD08\uB2F9 \uD83D\uDEF8 x2',

  ach_p01: '\uCCAB \uBC88\uC9F8 \uC7AC\uD3B8', ach_p01_reward: '\uD83D\uDC8E +5 \uBCF4\uB108\uC2A4',
  ach_p02: '\uC21C\uD658\uC758 \uB9DB', ach_p02_reward: '\uD83D\uDC8E \uD68D\uB4DD +10%',
  ach_p03: '\uBCA0\uD14C\uB791 \uC694\uC6D0', ach_p03_reward: '\uD83D\uDC8E \uD68D\uB4DD +10%',
  ach_p04: '\uD658\uC0DD \uC911\uB3C5', ach_p04_reward: '\uD83D\uDC8E \uD68D\uB4DD +15%',
  ach_p05: '\uBB34\uD55C \uB8E8\uD504', ach_p05_reward: '\uD83D\uDC8E \uD68D\uB4DD +20%',
  ach_p06: '\uC740\uD558\uC758 \uAE30\uC5B5', ach_p06_reward: '\uD83D\uDC8E \uD68D\uB4DD +25%',
  ach_p07: '\uC740\uD558 \uC7AC\uD3B8', ach_p07_reward: '\uD83D\uDD2E +3 \uBCF4\uB108\uC2A4',
  ach_p08: '\uCC28\uC6D0\uC758 \uC9C0\uBC30\uC790', ach_p08_reward: '\uD83D\uDD2E \uD68D\uB4DD +20%',

  ach_h01: '\uC2E0\uC785 \uCD9C\uADFC', ach_h01_reward: '\uD658\uC601 \uBCF4\uB108\uC2A4 \uD83D\uDEF8 100',
  ach_h02: '1\uC2DC\uAC04 \uADFC\uBB34', ach_h02_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +5%',
  ach_h03: '\uBC18\uB098\uC808', ach_h03_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_h04: '24\uC2DC\uAC04 \uC7A0\uBCF5', ach_h04_reward: '\uC624\uD504\uB77C\uC778 \uCE61 +2\uC2DC\uAC04',
  ach_h05: '3\uC77C \uC791\uC804', ach_h05_reward: '\uCD08\uB2F9 \uD83D\uDEF8 x1.5',
  ach_h06: '\uC77C\uC8FC\uC77C \uCE68\uD22C', ach_h06_reward: '\uCD08\uB2F9 \uD83D\uDEF8 x2',

  ach_s01: '\uC758\uC2EC \uB9CE\uC740 \uC778\uAC04', ach_s01_reward: '\uAE30\uBC00 \uBB38\uC11C 1',
  ach_s02: '\uAE68\uB057\uD55C \uCD9C\uBC1C', ach_s02_reward: '\uCE6D\uD638: \uBB34\uBAA8\uD55C \uC694\uC6D0',
  ach_s03: '\uC62C\uC778', ach_s03_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_s04: '\uC2A4\uD53C\uB4DC\uB7F0', ach_s04_reward: '\uD83D\uDC8E +10 \uBCF4\uB108\uC2A4',
  ach_s05: '\uACE8\uB4E0 \uD5CC\uD130', ach_s05_reward: '\uC774\uBCA4\uD2B8 \uC8FC\uAE30 -20%',
  ach_s06: '\uBC24\uC758 \uC694\uC6D0', ach_s06_reward: '야간 초당 🛸 x1.5',
  ach_s07: '\uBB34\uACFC\uAE08 \uC804\uC0AC', ach_s07_reward: '\uAD11\uACE0 \uBCF4\uC0C1 +30%',
  ach_s08: '\uC218\uC9D1\uAD11', ach_s08_reward: '\uCD08\uB2F9 \uD83D\uDEF8 x3',

  ach_a01: '\uAD11\uACE0 \uC785\uBB38', ach_a01_reward: '\uAE30\uBC00 \uBB38\uC11C 1',
  ach_a02: '\uAD11\uACE0 \uC560\uD638\uAC00', ach_a02_reward: '\uAE30\uBC00 \uBB38\uC11C 2',
  ach_a03: '\uAD11\uACE0 \uB9C8\uC2A4\uD130', ach_a03_reward: '\uAD11\uACE0 \uBCF4\uC0C1 +30%',
  ach_a04: '\uBB38\uC11C \uC218\uC9D1\uAC00', ach_a04_reward: '\uBB38\uC11C \uD6A8\uACFC +20%',
  ach_a05: '\uAE30\uBC00 \uC804\uBB38\uAC00', ach_a05_reward: '\uBB38\uC11C \uD6A8\uACFC +50%',

  ach_c01: '\uC5F0\uD0C0\uC758 \uC2DC\uC791', ach_c01_reward: '\uCF64\uBCF4 \uC720\uC9C0 +0.3\uCD08',
  ach_c02: '\uB9AC\uB4EC \uD0C0\uAE30', ach_c02_reward: '\uCF64\uBCF4 \uBC30\uC728 +0.1',
  ach_c03: '\uACE8\uB4E0 \uCD08\uBCF4', ach_c03_reward: '\uC774\uBCA4\uD2B8 \uBCF4\uC0C1 +10%',
  ach_c04: '\uACE8\uB4E0 \uC218\uC9D1\uAC00', ach_c04_reward: '\uC774\uBCA4\uD2B8 \uC8FC\uAE30 -10%',
  ach_c05: '\uC77C\uC77C \uBBF8\uC158 \uB9C8\uB2C8\uC544', ach_c05_reward: '\uBBF8\uC158 \uBCF4\uC0C1 +50%',

  golden_intel_leak: '\uAE30\uBC00 \uC815\uBCF4 \uC720\uCD9C!', golden_agent_frenzy: '\uC694\uC6D0 \uAD11\uB780!',
  golden_money_launder: '\uC790\uAE08 \uC138\uD0C1!', golden_facility_boost: '\uC2DC\uC124 \uAC00\uB3D9\uB960 UP!',
  golden_supply_drop: '\uC740\uD558 \uBCF4\uAE09\uD488!', golden_touch: '\uD0ED!', golden_ad_double: '\uAD11\uACE0 \uBCF4\uACE0 2\uBC30',

  offline_title: '\uBD80\uC7AC \uC911 \uC791\uC804 \uBCF4\uACE0\uC11C', offline_elapsed: '\uACBD\uACFC \uC2DC\uAC04',
  offline_earned: '\uD68D\uB4DD \uD83D\uDEF8', offline_cap: '\uCD5C\uB300 {h}\uC2DC\uAC04 \uC801\uC6A9',
  offline_claim: '\uBC1B\uAE30', offline_double: '\uAD11\uACE0 \uBCF4\uACE0 2\uBC30 \uBC1B\uAE30 ({amount})',
  offline_hours: '{h}\uC2DC\uAC04 {m}\uBD84',

  settings_title: '\uC124\uC815', settings_bgm: 'BGM', settings_sfx: '\uD6A8\uACFC\uC74C', settings_lang: '\uC5B8\uC5B4',
  settings_reset: '\uAC8C\uC784 \uCD08\uAE30\uD654', settings_reset_confirm: '\uBAA8\uB4E0 \uC9C4\uD589 \uC0C1\uD669\uC744 \uC0AD\uC81C\uD558\uACE0 \uCC98\uC74C\uBD80\uD130 \uC2DC\uC791\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
  settings_stats: '\uD1B5\uACC4', settings_total_ip: '\uCD1D \uD68D\uB4DD \uD83D\uDEF8', settings_total_taps: '\uCD1D \uD0ED \uD69F\uC218',
  settings_total_prestiges: '\uCD1D \uD658\uC0DD \uD69F\uC218', settings_play_time: '\uCD1D \uD50C\uB808\uC774 \uC2DC\uAC04',
  settings_docs_shop: '\uAE30\uBC00 \uBB38\uC11C \uC0C1\uC810',

  doc_shop_title: '\uAE30\uBC00 \uBB38\uC11C \uC0C1\uC810',
  doc_ip_boost: '자동 수익 가속', doc_ip_boost_desc: '30초간 초당 🛸 생산량 2배',
  doc_mega_tap: '강화 탭 훈련', doc_mega_tap_desc: '30초간 탭 수익 3배',
  doc_auto_click: '자동 침투 장치', doc_auto_click_desc: '30초간 초당 10회 자동 탭',
  doc_instant_golden: '긴급 골든 소환', doc_instant_golden_desc: '골든 이벤트 즉시 발동',
  doc_timeskip: '시간 가속기', doc_timeskip_desc: '2시간치 🛸 수익 즉시 획득',
  doc_prestige_boost: '은하 증폭기', doc_prestige_boost_desc: '다음 환생 시 💎 획득량 2배',
  doc_prestige_boost_active: '다음 환생 시 💎 x2 적용 대기 중', doc_prestige_boost_active_badge: '✅ 적용 대기 중',

  ad_offline_double: '\uC624\uD504\uB77C\uC778 \uBCF4\uC0C1 2\uBC30', ad_cps_boost: '\uCD08\uB2F9 \uC218\uC775 x10 (15\uCD08)',
  ad_prestige_bonus: '\uD658\uC0DD \uD83D\uDC8E +50%', ad_timeskip: '\uD0C0\uC784\uC2A4\uD0B5 (2\uC2DC\uAC04)',
  ad_free_docs: '\uBB34\uB8CC \uAE30\uBC00 \uBB38\uC11C', ad_golden_double: '\uACE8\uB4E0 \uBCF4\uC0C1 2\uBC30',
  ad_start_boost: '\uC2A4\uD0C0\uD2B8 \uBD80\uC2A4\uD2B8 \uD329', ad_watching: '\uAD11\uACE0 \uB85C\uB529 \uC911...',
  ad_cooldown: '{t} \uD6C4 \uC0AC\uC6A9 \uAC00\uB2A5',
  settings_sfx_test: '\uD6A8\uACFC\uC74C \uD14C\uC2A4\uD2B8',
  settings_sound_reset: '\uCD08\uAE30\uD654',
  settings_sound_reset_done: '\uC0AC\uC6B4\uB4DC\uAC00 \uCD08\uAE30\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4',

  num_k: '\uB9CC', num_m: '\uC5B5', num_b: '\uC870', num_t: '\uACBD', num_qa: '\uD574',
  num_qi: '\uC790', num_sx: '\uC591', num_sp: '\uAD6C', num_oc: '\uAC04', num_no: '\uC815', num_dc: '\uC7AC',

  // Daily Missions
  mission_title: '\uC77C\uC77C \uBBF8\uC158',
  mission_claim: '\uBC1B\uAE30',
  mission_all_complete: '\uC804\uCCB4 \uC644\uB8CC \uBCF4\uB108\uC2A4!',
  mission_clear_label: '\uBBF8\uC158',
  mission_all_clear_label: '\uC62C\uD074\uB9AC\uC5B4',
  ach_unlock_label: '\uC5C5\uC801',
  mission_diff_easy: '\uC27D\uAC8C',
  mission_diff_normal: '\uBCF4\uD1B5',
  mission_diff_hard: '\uC5B4\uB835\uAC8C',
  mission_tap_100: '\uAC00\uBCBC\uC6B4 \uD130\uCE58',
  mission_tap_100_desc: '100\uD68C \uD0ED\uD558\uAE30',
  mission_tap_300: '\uC190 \uD480\uAE30',
  mission_tap_300_desc: '300\uD68C \uD0ED\uD558\uAE30',
  mission_buy_5: '\uC18C\uADDC\uBAA8 \uBAA8\uC9D1',
  mission_buy_5_desc: '\uC0DD\uC0B0\uAE30 5\uAC1C \uAD6C\uB9E4',
  mission_combo_10: '\uCF64\uBCF4 \uC2DC\uC791',
  mission_combo_10_desc: '10 \uCF64\uBCF4 \uB2EC\uC131',
  mission_golden_1: '\uD669\uAE08 \uCEA0\uCE58',
  mission_golden_1_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 1\uD68C \uD130\uCE58',
  mission_tap_1000: '\uAC15\uB825\uD55C \uD0ED',
  mission_tap_1000_desc: '1,000\uD68C \uD0ED\uD558\uAE30',
  mission_buy_20: '\uBD80\uB300 \uAD6C\uCD95',
  mission_buy_20_desc: '\uC0DD\uC0B0\uAE30 20\uAC1C \uAD6C\uB9E4',
  mission_combo_50: '\uCF64\uBCF4 \uD504\uB85C',
  mission_combo_50_desc: '50 \uCF64\uBCF4 \uB2EC\uC131',
  mission_golden_3: '\uACE8\uB4DC \uB7EC\uC2DC',
  mission_golden_3_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 3\uD68C \uD130\uCE58',
  mission_earn_1m: '\uBC31\uB9CC \uC791\uC804',
  mission_earn_1m_desc: '\uD83D\uDEF8 100\uB9CC \uD68D\uB4DD',
  mission_tap_5000: '\uD0ED \uBA38\uC2E0',
  mission_tap_5000_desc: '5,000\uD68C \uD0ED\uD558\uAE30',
  mission_buy_50: '\uAD70\uB2E8 \uAD6C\uCD95',
  mission_buy_50_desc: '\uC0DD\uC0B0\uAE30 50\uAC1C \uAD6C\uB9E4',
  mission_combo_100: '\uCF64\uBCF4 \uC2E0',
  mission_combo_100_desc: '100 \uCF64\uBCF4 \uB2EC\uC131',
  mission_golden_5: '\uACE8\uB4E0 \uB9C8\uC2A4\uD130',
  mission_golden_5_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 5\uD68C \uD130\uCE58',
  mission_earn_1b: '\uC5B5 \uB2E8\uC704 \uC694\uC6D0',
  mission_earn_1b_desc: '\uD83D\uDEF8 10\uC5B5 \uD68D\uB4DD',
  mission_tap_200: '빠른 손가락',
  mission_tap_200_desc: '200번 탭하기',
  mission_buy_3: '첫 모집',
  mission_buy_3_desc: '생산자 3명 구매',
  mission_combo_15: '콤보 입문',
  mission_combo_15_desc: '15 콤보 달성',
  mission_earn_10k: '용돈벌이',
  mission_earn_10k_desc: '🛸 10K 획득',
  mission_earn_100k: '자금 모금',
  mission_earn_100k_desc: '🛸 100K 획득',
  mission_tap_500: '꾸준한 탭',
  mission_tap_500_desc: '500번 탭하기',
  mission_tap_700: '끈질긴 손',
  mission_tap_700_desc: '700번 탭하기',
  mission_buy_10: '팀장',
  mission_buy_10_desc: '생산자 10명 구매',
  mission_combo_30: '콤보 체인',
  mission_combo_30_desc: '30 콤보 달성',
  mission_golden_2: '더블 골드',
  mission_golden_2_desc: '골든 이벤트 2번 터치',
  mission_tap_3000: '탭 전사',
  mission_tap_3000_desc: '3,000번 탭하기',
  mission_buy_30: '대대',
  mission_buy_30_desc: '생산자 30명 구매',
  mission_combo_75: '콤보 엘리트',
  mission_combo_75_desc: '75 콤보 달성',
  mission_golden_4: '골드 헌터',
  mission_golden_4_desc: '골든 이벤트 4번 터치',
  mission_earn_10m: '재벌',
  mission_earn_10m_desc: '🛸 10M 획득',

  // Conquest
  cq_title: '세계 정복',
  cq_progress: '정복 현황',
  cq_infiltration_power: '침투력',
  cq_active_conquest: '침투 중',
  cq_infiltration_progress: '침투 진행도',
  cq_time_remaining: '예상 완료 시간',
  cq_start_infiltration: '침투 시작',
  cq_stop_infiltration: '침투 중지',
  cq_no_power_hint: '요원을 고용하면 침투력이 생깁니다',
  cq_locked: '잠김',
  cq_available: '침투 가능',
  cq_conquered: '정복 완료',
  cq_popup_title: '정복 완료!',
  cq_popup_desc: '을(를) 정복했습니다! 시설을 건설하여 더 강해지세요.',
  cq_back: '뒤로',
  cq_invest_title: '🛸를 투자하여 정복',
  cq_current_ip: '보유 🛸',
  cq_facilities: '시설',
  cq_build: '건설',
  cq_upgrade: '강화',
  cq_next_level: '다음',
  cq_counter_intel_title: '방첩 경보!',
  cq_counter_intel_text: '{country}에서 침투가 발각되었습니다! 진행도가 감소합니다.',
  cq_defend_ad: '광고 보고 방어',
  cq_accept_loss: '손실 감수',
  cq_ending_title: '지구 정복 완료!',
  cq_ending_text: '렙틸리언 음모가 완성되었습니다. 모든 국가가 그림자 제국 앞에 무릎을 꿇었습니다.',
  cq_ending_time: '플레이 시간',
  cq_ending_prestiges: '환생 횟수',
  cq_ending_total_ip: '총 🛸',
  cq_ending_taps: '총 탭 수',
  cq_ending_continue: '계속 플레이',
  // Countries
  cq_egypt: '이집트', cq_egypt_desc: '피라미드 고대 기지',
  cq_brazil: '브라질', cq_brazil_desc: '아마존 밀림 은신처',
  cq_india: '인도', cq_india_desc: '나가 신앙 침투',
  cq_australia: '호주', cq_australia_desc: '사막 지하 벙커',
  cq_japan: '일본', cq_japan_desc: '기술 탈취 작전',
  cq_korea: '한국', cq_korea_desc: 'NIS 사이버 방어 돌파',
  cq_uk: '영국', cq_uk_desc: 'MI5/MI6 왕실 침투',
  cq_russia: '러시아', cq_russia_desc: 'FSB 시베리아 작전',
  cq_china: '중국', cq_china_desc: '세계 최강 감시망',
  cq_usa: '미국', cq_usa_desc: 'CIA/NSA 최종 보스',
  // Facilities
  fac_pyramid_vault: '피라미드 금고', fac_pyramid_vault_d: '레벨당 초당 🛸 +5%',
  fac_nile_network: '나일 네트워크', fac_nile_network_d: '레벨당 오프라인 +5%',
  fac_ancient_lab: '고대 연구소', fac_ancient_lab_d: '레벨당 TAP +10%',
  fac_amazon_hideout: '아마존 은신처', fac_amazon_hideout_d: '레벨당 생산자 할인 +2%',
  fac_samba_broadcast: '삼바 방송국', fac_samba_broadcast_d: '레벨당 초당 🛸 +8%',
  fac_jungle_lab: '정글 연구소', fac_jungle_lab_d: '레벨당 골든 이벤트 +5%',
  fac_naga_temple: '나가 사원', fac_naga_temple_d: '레벨당 💎 +5%',
  fac_bollywood_studio: '볼리우드 스튜디오', fac_bollywood_studio_d: '레벨당 오프라인 +8%',
  fac_caste_network: '카스트 네트워크', fac_caste_network_d: '레벨당 초당 🛸 +12%',
  fac_desert_bunker: '사막 벙커', fac_desert_bunker_d: '레벨당 TAP +15%',
  fac_ayers_signal: '에어즈록 신호기', fac_ayers_signal_d: '레벨당 골든 이벤트 +8%',
  fac_outback_base: '아웃백 기지', fac_outback_base_d: '레벨당 초당 🛸 +15%',
  fac_akiba_ai: '아키하바라 AI', fac_akiba_ai_d: '레벨당 초당 🛸 +20%',
  fac_ninja_intel: '닌자 정보부', fac_ninja_intel_d: '레벨당 생산자 할인 +3%',
  fac_tokyo_tower: '도쿄 타워', fac_tokyo_tower_d: '레벨당 💎 +8%',
  fac_gangnam_hq: '강남 본부', fac_gangnam_hq_d: '레벨당 초당 🛸 +25%',
  fac_cyber_command: '사이버 사령부', fac_cyber_command_d: '레벨당 TAP +25%',
  fac_kpop_brainwash: 'K-Pop 세뇌기', fac_kpop_brainwash_d: '레벨당 💎 +10%',
  fac_royal_infiltrate: '왕실 침투', fac_royal_infiltrate_d: '레벨당 초당 🛸 +30%',
  fac_london_tower: '런던 타워', fac_london_tower_d: '레벨당 오프라인 +15%',
  fac_mi6_double: 'MI6 이중첩자', fac_mi6_double_d: '레벨당 골든 이벤트 +12%',
  fac_siberia_base: '시베리아 기지', fac_siberia_base_d: '레벨당 초당 🛸 +40%',
  fac_kgb_remnant: 'KGB 잔당', fac_kgb_remnant_d: '레벨당 생산자 할인 +5%',
  fac_nuke_bunker: '핵 벙커', fac_nuke_bunker_d: '레벨당 TAP +40%',
  fac_great_wall: '만리방화벽', fac_great_wall_d: '레벨당 초당 🛸 +50%',
  fac_shenzhen_factory: '선전 공장', fac_shenzhen_factory_d: '레벨당 생산자 할인 +8%',
  fac_panda_spy: '팬더 스파이링', fac_panda_spy_d: '레벨당 골든 이벤트 +20%',
  fac_area51: '에어리어 51', fac_area51_d: '레벨당 초당 🛸 +80%',
  fac_pentagon: '펜타곤', fac_pentagon_d: '레벨당 TAP +80%',
  fac_wall_street: '월스트리트', fac_wall_street_d: '레벨당 💎 +25%',

  buy: '\uAD6C\uB9E4', max: '\uCD5C\uB300', level: 'Lv.', locked: '\uC7A0\uAE40', unlocked: '\uD574\uAE08',
  upgrade_locked_prev: '\uC774\uc804 \uc5c5\uadf8\ub808\uc774\ub4dc\ub97c \uba3c\uc800 \ubc30\uc6b0\uc138\uc694',
  condition: '\uC870\uAC74', cost: '\uBE44\uC6A9', owned: '\uBCF4\uC720', effect: '\uD6A8\uACFC', reward: '\uBCF4\uC0C1',
  close: '\uB2EB\uAE30', confirm: '\uD655\uC778', cancel: '\uCDE8\uC18C',

  // Conquest achievements
  ach_filter_conquest: '정복',
  ach_q01: '첫 번째 점령', ach_q01_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_q02: '세 나라 점령', ach_q02_reward: 'TAP +10%',
  ach_q03: '절반의 세계', ach_q03_reward: '💎 획득 +15%',
  ach_q04: '일곱 깃발', ach_q04_reward: '오프라인 효율 +20%',
  ach_q05: '세계 정복자', ach_q05_reward: '전체 초당 🛸 x3',
  ach_q06: '시설 마스터', ach_q06_reward: '전체 초당 🛸 x2',
  milestone_next: '다음',
  settings_conquest: '정복 현황',

  // Currency info
  currency_ip_name: '침투 포인트 (IP)',
  currency_ip_earn: '탭, 요원 자동생산, 오프라인 수익, 광고 보상으로 획득',
  currency_ip_use: '요원 고용, 업그레이드 구매, 국가 정복에 투자',
  currency_gc_name: '은하 크레딧 (GC)',
  currency_gc_earn: '환생(조직 재편) 시 누적 IP에 비례하여 획득',
  currency_gc_use: '환생 업그레이드 구매 (생산 배율, 오프라인 효율 등)',
  currency_cores_name: '은하 코어',
  currency_cores_earn: '2차 환생(은하 재편) 시 누적 GC에 비례하여 획득',
  currency_cores_use: '2차 환생 업그레이드 구매 (영구 버프, 자동화 등)',
  currency_docs_name: '기밀 문서',
  currency_docs_earn: '일일 미션 완료, 광고 시청, 업적 달성으로 획득',
  currency_docs_use: '미션 탭의 기밀문서 상점에서 강력한 부스트 아이템 구매',
  currency_how_earn: '획득 방법',
  currency_how_use: '사용처',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: '침투 숙련',
  pup_infiltration_mastery_desc: '레벨당 전체 침투력 +50% (최대 +500%)',
  pup_agent_network: '요원 네트워크',
  pup_agent_network_desc: '레벨당 요원 100명마다 침투력 +5%',
  pup_quick_infiltration: '연쇄 침투',
  pup_quick_infiltration_desc: '나라 정복 시 다음 나라 진행도 +10%/Lv',
  pup_critical_chance: '치명타 훈련',
  pup_critical_chance_desc: '탭 치명타 확률 +3%/Lv (기본 10%, 최대 50%)',
  pup_critical_damage: '치명타 강화',
  pup_critical_damage_desc: '치명타 데미지 +1x/Lv (기본 x3)',

  // Special upgrades - conquest
  special_spy_master: '스파이 마스터',
  special_spy_master_desc: '전체 침투력 x2',

  // Ad reward popups
  ad_income_x5: '30분치 수입 받기',
  ad_income_x5_desc: '광고를 시청하면 현재 초당 수익 30분분인\n{amount} 🛸를 즉시 획득합니다!',
  ad_tap_x10: '터치 x10 (10초)',
  ad_tap_x10_desc: '광고를 시청하면 10초 동안\n탭 수익이 10배로 증가합니다!',
  ad_free_docs_desc: '광고를 시청하면\n기밀 문서 📜 1개를 무료로 획득합니다!',
  ad_prestige_desc: '광고를 시청하면\n15초 동안 초당 수익이 10배로 증가합니다!',
  cq_tutorial_title: '🌍 세계 정복 안내',
  cq_tutorial_text: '국가를 정복하면 <b>시설</b>을 건설할 수 있습니다!\n시설을 강화하면 초당 수익, 탭 수익, 오프라인 수익 등\n<b>영구적인 보너스</b>를 얻을 수 있습니다.\n\n요원을 고용하면 침투력이 올라갑니다.',
  rank_promote: '승급',
  rank_promoted: '승급 완료!',
} as const;
